import Title from './Title';
import ValidFrom from './ValidFrom';
import ValidTo from './ValidTo';
import Created from './Created';
import Updated from './Updated';
import Status from './Status';
import StartDate from './StartDate';
import Shop from './Shop';
import User from './User';
import Type from './Type';

export const labels = {
  Title: 'Cím',
  Status: 'Státusz',
  ValidFrom: 'Érvényesség kezdete',
  ValidTo: 'Érvényesség vége',
  Updated: 'Módosítva',
  Created: 'Létrehozva',
  StartDate: 'Kezdve ekkor',
  Shop: 'Üzlet',
  User: 'Felelős',
  Type: 'Típus',
};

export const allColumns = [{
  value: 'Title',
  fixed: true,
}, {
  value: 'ValidFrom',
}, {
  value: 'ValidTo',
}, {
//   value: 'Updated',
// }, {
//   value: 'Created',
// }, {
//   value: 'Status',
// }, {
//   value: 'StartDate',
// }, {
//   value: 'Shop',
// }, {
//   value: 'User',
// },{
  value: 'Type',
}];

export const defaultColumns = [{
  value: 'Title',
  fixed: true,
}, {
//   value: 'Status',
// }, {
//   value: 'Shop',
// }, {
  value: 'Type',
// }, {
//   value: 'User',
// }, {
//   value: 'StartDate',
}];

export const defaultSort = {
  prop: StartDate.propName,
  order: 'ascending'
};

export default {
  Title,
  ValidFrom,
  ValidTo,
  // Created,
  // Updated,
  // Status,
  // StartDate,
  // Shop,
  // User,
  Type,
};
